import { Card, CardBody, Col, Row } from "reactstrap";
import { COURSE_BOX_DATA } from "../../../../Data/Widgets/GeneralWidgets";
import { H4, SVG } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import SquareGroup from "./SquareGroup";

const CourseBox = () => {
  return (
    <Col xxl="3" xl="4" md="6" className="box-col-6">
      <Row>
        {COURSE_BOX_DATA.map((data, index) => (
          <Col sm="12" key={index}>
            <Card className="course-box widget-course">
              <CardBody>
                <div className="course-widget">
                  <div className={`course-icon ${data.color ? data.color : ""}`}>
                    <SVG className="fill-icon" iconId={data.icon} />
                  </div>
                  <div>
                    <H4 className="mb-0">{data.course}</H4>
                    <span className="f-light">{data.title}</span>
                    <Link className="btn btn-light f-light" to={`${process.env.PUBLIC_URL}/learning/learning-list-view`}>
                      {data.link}
                      <span className="ms-2">
                        <SVG className="fill-icon f-light" iconId="arrowright"/>
                      </span>
                    </Link>
                  </div>
                </div>
              </CardBody>
              <SquareGroup />
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default CourseBox;
